
import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import MessageBox from '@/components/shared/MessageBox'
import {SUCCESS_MESSAGE_TYPE} from '@/utils/constants'
@Component({
    components: {
        MessageBox,
    },
})
export default class AnalysisCode extends Vue {
    @Prop()
    private analysis: AnalysisVO

    @Prop()
    private isFinished: boolean

    private message = 'No dangerous code detected.'
    private messageType = SUCCESS_MESSAGE_TYPE

    private getClassName(level: string): string {
        if (level === 'high') {
            return 'has-background-danger'
        }
        if (level === 'info') {
            return 'has-background-info'
        }
        if (level === 'warning') {
            return 'has-background-warning'
        }
        return 'has-background-success'
    }
    
    private clearMessage() {
        this.message = ''
    }

    private hasCode() {
        return this.analysis &&
            this.analysis.staticReport &&
            this.analysis.staticReport.code_analysis &&
            Object.keys(this.analysis.staticReport.code_analysis).length > 0
    }

    private getSize(){
        return Object.keys(this.analysis.staticReport.code_analysis).length
    }
}
